import { Stack, Typography } from "@mui/material";
import { ChatUserSearchResultRow } from "Components/Chat/ChatUserSearchResultRow";
import type { SocialUserSearchDto } from "Infrastructure/Api/Api";

type Props = {
  title: string;
  users: ReadonlyArray<SocialUserSearchDto>;
  selectedUserIDs: ReadonlyArray<string>;
  existingMemberIDs?: ReadonlyArray<string>;
  isFullMooneRequired?: boolean;
  isMultiSelect?: boolean;
  onSelectUser: (user: SocialUserSearchDto) => void;
};

/** A titled list of picker rows — the suggestions, or the results of a search. */
export const ChatUserSearchSection = ({
  title,
  users,
  selectedUserIDs,
  existingMemberIDs,
  isFullMooneRequired,
  isMultiSelect,
  onSelectUser,
}: Props) => (
  <Stack gap={2}>
    <Typography variant="subtitle2">{title}</Typography>
    <Stack gap={2}>
      {users.map((user) => (
        <ChatUserSearchResultRow
          key={user.identityUserPublicID}
          user={user}
          isSelected={selectedUserIDs.includes(user.identityUserPublicID)}
          isExistingMember={
            existingMemberIDs?.includes(user.identityUserPublicID) ?? false
          }
          isFullMooneRequired={isFullMooneRequired}
          isMultiSelect={isMultiSelect}
          onSelect={onSelectUser}
        />
      ))}
    </Stack>
  </Stack>
);
